import { EmailInUseError, UnexpectedError } from "../../../domain/errors";
import { GetMetersByStatus } from "../../../domain/usecases/get-meters-by-status";
import { HttpClient, HttpStatusCode } from "../../protocols/http";

export class RemoteGetMetersByStatus implements GetMetersByStatus {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<RemoteGetMetersByStatus.Model>
  ) {}

  async fetch(
    params: GetMetersByStatus.Params
  ): Promise<RemoteGetMetersByStatus.Model> {
    console.log("body: params,", params);

    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: params,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body!;
      case HttpStatusCode.forbidden:
        throw new EmailInUseError();
      default:
        throw new UnexpectedError();
    }
  }
}

export namespace RemoteGetMetersByStatus {
  export type Model = GetMetersByStatus.Model;
}
